<template>
  <div class="container mt-5">
    <div class="row">
      <div class="col-md-4">
        <vx-card title="Registro de bonos">
          <vs-input
            label="PID"
            @change="pidChangeHandler"
            v-model="projectId"></vs-input>

          <template v-if="project">
            <vs-input
              label="CID"
              v-model="this.project.client_id" disabled></vs-input>

            <vs-input
              v-if="chargeSelected"
              v-model="bonusPercentage"
              label="% Bono"
              @change="bonusHandler"></vs-input>

            <vs-input
              label="Monto + IVA"
              type="number" v-model="amount"></vs-input>
          </template>

          <vs-button
            @click="showDialogHandler()"
            class="mt-5 small" :disabled="!project || amount === 0">
            Crear bono
          </vs-button>
        </vx-card>
      </div>


      <vs-popup
        title="Confirmación"
        :active.sync="showDialog">
        <vs-alert color="primary" style="height: auto;">
          <span>Se crearán las siguientes transacciones. ¿Desea continuar?</span>
        </vs-alert>

        <vs-table class="mt-10" :data="operationsPreview">
          <template slot="thead">
            <vs-th>Concepto</vs-th>
            <vs-th>Monto</vs-th>
            <vs-th>Status</vs-th>
            <vs-th>Trx Type</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr v-for="o in data" :key="o.trx_type">
              <vs-td>{{o.concept}}</vs-td>
              <vs-td>{{o.amount|currency}}</vs-td>
              <vs-td>{{o.status}}</vs-td>
              <vs-td>{{o.trx_type}}</vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <vs-button
          class="mt-5 float-right"
          @click="submitHandler()">Confirmar</vs-button>
      </vs-popup>


      <div class="col-md-8">
        <vx-card title="Abonos del solicitante">
          <ul class="list-group">
            <li
              @click="chargeSelected = charge"
              v-for="charge in charges"
              :class="{'active': isChargeSelected(charge.id)}"
              class="list-group-item list-group-item-action flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{charge.concept}}</h5>
                <small>{{charge.created_at}}</small>
              </div>
              <p class="mb-1">{{charge.amount|currency}}</p>
            </li>
          </ul>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import {currency} from "@/filters/currency";
import swal from "sweetalert";

export default {
  name: "CreateNewBonus",
  data: () => ({
    operationsPreview: [],
    showDialog: false,
    project: null,
    charges: [],
    bonusPercentage: 0,
    chargeSelected: null,
    projectId: null,
    amount: 0
  }),
  filters: {
    currency
  },
  methods: {
    async showDialogHandler() {
      try {
        let response = await axios.get(`/api/bonus/applicant?project_id=${this.projectId}&amount=${this.amount}`)
        this.operationsPreview = response.data;
        this.showDialog = true
      } catch (e) {
        await swal('Error', e.message, 'danger');
      }
    },
    async pidChangeHandler() {
      this.$vs.loading();
      try {
        const {data} = await axios.get(`/api/v2/projects/${this.projectId}`)
        this.project = data;

        let result = await axios.get(`/api/charge/applicant/${this.project.client_id}?project_id=${this.projectId}&trx_type=C262`);
        this.charges = result.data;
      } finally {
        this.$vs.loading.close();
      }
    },
    isChargeSelected(chargeId) {
      if(this.chargeSelected) {
        return this.chargeSelected.id === chargeId;
      }
      return false;
    },
    bonusHandler(ev) {
      let bonusDecimalPercentage = this.bonusPercentage / 100;
      this.amount = (this.chargeSelected.amount *  bonusDecimalPercentage).toFixed(2);
    },
    resetForm() {
      this.project = null;
      this.chargeSelected = null;
      this.projectId = null;
      this.amount = 0;
      this.bonusPercentage = 0;
      this.charges = [];
    },
    async submitHandler() {
      try {
        await axios.post(`/api/bonus/applicant`, {
          "project_id": this.projectId,
          "amount": this.amount
        })
        this.showDialog = false;
        await swal("Notificación", "El bono se ha creado correctamente", "success")
      } catch (e) {
        await swal("Alerta", e.toString(), "warning")
      } finally {
        this.resetForm();
      }
    }
  }
}
</script>

<style scoped>

</style>
